import { combineReducers } from 'redux';
import {
  AddAppointmentReducer,
  UpdateAppointmentReducer,
  GetAppointmentReducer,
  GetAppointmentsReducer,
} from './appointments-reducer';

const appointmentRootReducer = combineReducers({
  addAppointment: AddAppointmentReducer,
  update_appointment: UpdateAppointmentReducer,
  getAppointment: GetAppointmentReducer,
  appointmentList: GetAppointmentsReducer,
});

export default appointmentRootReducer;
